import {
  PUBLISH_VIDEO_ACCEPT as TIKTOK_PUBLISH_VIDEO_ACCEPT,
  isAllowedPublishVideoFormat,
  mapVideoSpaceRowToLibraryItem,
  filterPublishVideoLibraryRows,
  videoSpaceRecordToUploadFile,
  probeLocalVideoSize,
} from '@/pages/ipe/workbench/utils/videoSpaceLibraryPick';

/**
 * TikTok Upload Product File 对商品视频的硬性要求：
 * 画面比例须在 9:16 与 16:9 之间（官方推荐 1:1）。
 * 注意不要沿用 Temu 的 1:1 / 3:4 / 16:9 白名单——那会把 9:16、4:3 等平台合法视频误拦。
 */
const TIKTOK_VIDEO_MIN_RATIO = 9 / 16;
const TIKTOK_VIDEO_MAX_RATIO = 16 / 9;

export const TIKTOK_PUBLISH_VIDEO_RATIO_HINT =
  '主图视频：可选；MP4/MOV/M4V/WebM；≤20MB；画面比例须在 9:16 与 16:9 之间（建议 1:1）。支持本地文件或视频空间上传。';

/** 是否落在平台允许的 9:16 ~ 16:9 区间内 */
export function isTiktokAllowedVideoRatio(width, height, tolerance = 0.02) {
  const w = Number(width);
  const h = Number(height);
  if (!(w > 0) || !(h > 0)) return false;
  const ratio = w / h;
  return ratio >= TIKTOK_VIDEO_MIN_RATIO - tolerance
    && ratio <= TIKTOK_VIDEO_MAX_RATIO + tolerance;
}

/** 校验本地视频是否符合 TikTok 主图比例；不合规则抛出中文错误 */
export async function assertTiktokPublishVideoRatio(file) {
  const { width, height } = await probeLocalVideoSize(file);
  if (!isTiktokAllowedVideoRatio(width, height)) {
    throw new Error(
      `视频画面比例不符合要求（当前约 ${width}:${height}），须在 9:16 与 16:9 之间（建议 1:1）`,
    );
  }
  return { width, height };
}

export {
  TIKTOK_PUBLISH_VIDEO_ACCEPT,
  isAllowedPublishVideoFormat,
  mapVideoSpaceRowToLibraryItem,
  filterPublishVideoLibraryRows,
  videoSpaceRecordToUploadFile,
  probeLocalVideoSize,
};
